import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableLanguages',
  initialState: true,
  reducers: {
    setDisableLanguages(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableLanguages } = slice.actions;

export default slice.reducer;
